import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-up-left', 'ChevronUpLeft', [["path",{"d":"M8 16v-8h8"}]]);